import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var ArgosCardIcon = function ArgosCardIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5h18A1.5 1.5 0 0 1 22.5 6v12a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 18V6A1.5 1.5 0 0 1 3 4.5zM3 6v12h18V6H3zm6.185 8.901s2.271 1.294 5.537 0c0 0 .114-.038.167.012.053.05.022.084-.034.124-.056.04-2.885 2.157-5.835-.017 0 0-.054-.059.014-.133 0 0 .05-.039.151.014zM15 14.164s.016.206-.225.206h-.944s-.213-.005-.223-.19c-.01-.187-.046-1.13-.046-1.13H11.27l-.648 1.106s-.097.214-.296.214H9.25s-.23-.03-.14-.28c0 0 2.537-4.424 3.723-5.818 0 0 .172-.272.827-.272h.728s.303 0 .315.316c.012.315.296 5.848.296 5.848zm-3.211-2.22h1.792l-.112-2.522c-.013-.052-.055 0-.055 0-.477.604-1.625 2.522-1.625 2.522z"
  }));
};

ArgosCardIcon.displayName = 'ArgosCardIcon';
export default ArgosCardIcon;